import { AccountConnectionStatus } from 'types/gql-global-types'
import {
  XeroAccountsQuery_getDebitCardAccountsV2_accounts as XeroAccount,
  XeroAccountsQuery_getXeroBankfeedsConfiguration_bankAccounts as XeroBankAccount,
} from 'types/gql-types/XeroAccountsQuery'

export const isAccountSelected = (
  account: XeroAccount | null,
  selectedAccounts: XeroBankAccount[] = []
) => {
  return !!selectedAccounts.find(
    ({ id, accountConnectionStatus }) =>
      id === account?.id &&
      accountConnectionStatus === AccountConnectionStatus.LINKED
  )
}
